import { render, staticRenderFns } from "./Transportation.vue?vue&type=template&id=442bedda"
import script from "./Transportation.vue?vue&type=script&lang=js"
export * from "./Transportation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports